var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('company-form',{on:{"save":_vm.save,"back":_vm.back},model:{value:(_vm.entity),callback:function ($$v) {_vm.entity=$$v},expression:"entity"}}):_vm._e(),(_vm.loading)?_c('loading-page'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }